import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';

@Injectable({ providedIn: 'root' })
export class SnackbarService {

  constructor(private snackBar: MatSnackBar) {}

  public showError(error: HttpErrorResponse): Observable<any> {
    this.snackBar.open(error.error, error.status.toString(), {
      duration: 3000,
    });
    return of(error);
  }

  public showSuccess(r: string): Observable<any> {
    this.snackBar.open(r, '200', {
      duration: 3000,
    });
    return of(r);
  }

  public showNotifation(message: string): Observable<any> {
    this.snackBar.open(message, '', {
      duration: 3000,
    });
    return of(message);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/snackbar.service.ts